export const TOPICS = ["Book a demo", "Sales", "Support", "Security review", "Press", "Other"] as const;
export type Topic = (typeof TOPICS)[number];

/** `?topic=` values accepted by /contact. */
const TOPIC_PARAMS: Record<string, Topic> = {
  demo: "Book a demo",
  sales: "Sales",
  support: "Support",
  security: "Security review",
  "security-review": "Security review",
  press: "Press",
  other: "Other",
};

export function topicFromParam(raw: string | string[] | undefined): Topic | "" {
  const value = Array.isArray(raw) ? raw[0] : raw;
  return TOPIC_PARAMS[(value ?? "").trim().toLowerCase()] ?? "";
}
